.slider {
  appearance: none;
  -webkit-appearance: none;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  background: var(--color-bh-blue);
}
